import React from 'react'
import './MySkills.css'

function MySkills(){
    return (
        <div></div>
    );
}

export default MySkills